import { toError } from './parsers/error';
import { get } from '../../utils/utils';
export function initTopics(settings, http) {
  /**
   * Gets list of items
   * @param options
   * @returns {Promise}
   * @reject {Error}
   */
  function list(options) {
    options = options || {};
    const params = {
      locale: options.locale || 'en'
    };
    return http.get(`${settings.topicsListApiUrl}/_api/recommended-topics-server/topics`, params, {
      withCredentials: true
    }).then(response => ({
      ...response,
      data: get(response, 'data', [])
    })).catch(toError);
  }
  return {
    list
  };
}